<template>
  <div class="col-12 mx-auto overflow-hidden">
    <h1 class="title">Kostenlose Maschinenbewertung</h1>
    <div class="col-12 mx-auto border-box">
      <div class="flex stage-container mb3 small-border-radius">
        <div class="formstage bgcolor1 pointer" @click="changeStep((step = 0))">
          <p class="formstage-text passed">
            <svg
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 0.5C4.5 0.5 0 5 0 10.5C0 16 4.5 20.5 10 20.5C15.5 20.5 20 16 20 10.5C20 5 15.5 0.5 10 0.5ZM8 15.5L3 10.5L4.41 9.09L8 12.67L15.59 5.08L17 6.5L8 15.5Z"
                fill="#0176CD"
              />
            </svg>
            <span>Ihre Branche</span>
          </p>
          <span class="gray formstage-info">{{
            onboardingMachineBrancheDefault
          }}</span>
        </div>
        <div class="formstage bgcolor1">
          <p class="formstage-text passed">2. <span>Ihre Maschine</span></p>
        </div>
        <div class="formstage step-background-color">
          <p class="formstage-text">3. <span>Anschaffung</span></p>
        </div>
        <div class="formstage step-background-color">
          <p class="formstage-text">4. <span>Ihre Kontaktdaten</span></p>
        </div>
        <div class="formstage step-background-color">
          <p class="formstage-text">5. <span>Echtzeitbewertung</span></p>
        </div>
      </div>

      <div class="container container-step-2">
          <h2
            class="h-label"
            v-bind:class="{ error: notfilled }"
          >
            1. Maschinenkategorie
          </h2>
          <input-suggestion
            type="autosuggest"
            uri="/onboarding/suggest/machine-category"
            uri_suggest_key="machinecategory"
            uri_suggest_key_2="branche"
            event_name="machinecategory_selected"
            v-bind:trigger_open="machinecategory_trigger"
            v-bind:data_source="machinecategory_trigger_array"
            :placeholder="'CNC Drehfräszentrum, Kantenpresse, ...'"
            css_class="forminput"
            :validInput="isValid"
            :disabled="false"
            :branche="onboardingMachineBrancheDefault"
          ></input-suggestion>
          <br/>
        <div class="machine-box">
          <div
            class="manufacturer-box"
            :class="secondInputState ? 'disabledForminput' : ''"
          >
            <h2
              class="h-label"
              v-bind:class="{ error: notfilled }"
            >
              2. Hersteller
            </h2>
            <input-suggestion
              type="autosuggest"
              uri="/onboarding/suggest/manufacturer"
              uri_suggest_key="manufacturer"
              event_name="manufacturer_selected"
              v-bind:trigger_open="manufacturer_trigger"
              v-bind:data_source="manufacturer_trigger_array"
              placeholder="Hersteller"
              css_class="forminput"
              :validInput="isValid"
              :disabled="secondInputState"
            ></input-suggestion>
          </div>
          <br/>
          <div
            class="model-box"
            :class="thirdInputState ? 'disabledForminput' : ''"
          >
            <h2
              class="h-label"
              v-bind:class="{ error: notfilled }"
            >
              3. Maschinentyp / Modell
            </h2>
            <input-suggestion
              type="type_selection"
              uri="/onboarding/suggest/machine-category"
              uri_suggest_key="machinetype"
              event_name="machinetype_selected"
              v-bind:trigger_open="machinetype_trigger"
              v-bind:data_source="machinetype_trigger_array"
              placeholder="Maschinentyp / Modell"
              css_class="forminput"
              :validInput="isValid"
              :disabled="thirdInputState"
            ></input-suggestion>
          </div>
        </div>
        <div class="button-flexbox align-center">
          <div>
            <a class="zueruck" @click="changeStep((step = 0))">Zurück</a>
          </div>
          <div>
            <submit-button
              name="Bestätigen und weiter"
              :validInput="isValid"
              event_name="pre_submit_step_100"
            />
          </div>
        </div>
        <div class="mb4"></div>
      </div>
    </div>
    <cta-support-element />
  </div>
</template>

<script>
import { EventBus } from "@/event-bus.js";
import SubmitButton from "./SubmitButton.vue";
import InputSuggestion from "./InputSuggestion.vue";
import CTASupportElement from "./CTASupportElement.vue";
import axios from "axios";

export default {
  name: "OnboardingStep01",
  props: {
    onboardingMachineBrancheDefault: String,
    name: String,
    event_name: String,
    button_style: String,
  },
  data() {
    return {
      notfilled: false,
      debug: false,
      dataEvents: {
        machinecategory_selected: false,
      },

      onboardingMachineCategory: "",
      onboardingManufacturer: "",
      onboardingMachineType: "",

      machinecategory_trigger: false,
      machinecategory_trigger_array: [],
      machinecategory_input_text: "",

      manufacturer_trigger: false,
      manufacturer_trigger_array: [],
      manufacturer_input_text: "",

      machinetype_trigger: false,
      machinetype_trigger_array: [],
      machinetype_input_text: "",

      secondInputState: true,
      thirdInputState: true,
      isValid: false,
    };
  },
  mounted(){

  },
  watch: {

    onboardingMachineBrancheDefault: function () {
      
      switch (this.onboardingMachineBrancheDefault) {
        case "Metall":
          document.getElementsByClassName("forminput")[0].placeholder = "CNC Fräsmaschine, Rundbiegemaschine, ..."         
          break;
        case "Holz":
          document.getElementsByClassName("forminput")[0].placeholder = "Bandsäge, CNC Fräsmaschine, ..."        
          break;
        case "Druck":
          document.getElementsByClassName("forminput")[0].placeholder = "Falzmaschine, Offsetdruckmaschinen, ..."        
          break;
        case "Kunststoff":
          document.getElementsByClassName("forminput")[0].placeholder = "Spritzgießmaschine, Wickler, ..."        
          break;
        case "Bau":
          document.getElementsByClassName("forminput")[0].placeholder = "Raupenbagger, Radlader, ..."        
          break;
        case "Andere":
          document.getElementsByClassName("forminput")[0].placeholder = "Asphaltfräse, Belichter, ..."        
          break;  
        default:
          break;
      }        
    }  
  },
  created() {
    EventBus.$on("submit_step_100", () => {
      // Kein payload!
      this.log(this);
      this.log("OnboardingStep01 Event received: submit_step_100");
    });

    // category

    EventBus.$on("machinecategory_selected", (payload) => {
      this.log("OnboardingStep01 Event received: machinecategory_selected");
      this.log("OnboardingStep01 Event received: pre_submit_step_100");
      this.machinecategory_input_text = payload.input;

      if (this.machinecategory_input_text != "") {
        // Axios machen...
        let createURL =
          "https://enquiry.leaseback.private.color-und-code.de/onboarding/proof/machine-category";

        if (window.location.host == "onboarding.leaseback.de") {
          createURL =
            "https://enquiry.leaseback.de/onboarding/proof/machine-category";
        }
        let currentObj = this;
        axios
          .post(createURL, {
            machinecategory: currentObj.machinecategory_input_text,
            branche: currentObj.onboardingMachineBrancheDefault,
          })
          .then(function(response) {
            if (response.data.isValid == true) {
              currentObj.secondInputState = false;
            } else {
              currentObj.secondInputState = true;
            }
          })
          .catch(function(error) {
            currentObj.log("catch Function of AJAX-Called... error()");
            currentObj.log(error);
            currentObj.apiResponse = error;
          });
      }

      if (this.machinecategory_input_text == "") {
        this.secondInputState = true;
        this.thirdInputState = true;
        this.isValid = false;
      } else {
        if (
          this.manufacturer_input_text != "" &&
          this.machinetype_input_text != ""
        ) {
          this.isValid = true;
          this.secondInputState = false;
          this.thirdInputState = false;
        }
      }
    });

    // manufacturer

    EventBus.$on("manufacturer_selected", (payload) => {
      this.log("OnboardingStep02 Event received: manufacturer_selected");
      this.log("OnboardingStep02 Event received: pre_submit_step_200");
      this.manufacturer_input_text = payload.input;

      if (this.manufacturer_input_text != "") {
        //this.notfilled = false;
        // Axios machen...
        let createURL =
          "https://enquiry.leaseback.private.color-und-code.de/onboarding/proof/manufacturer";

        if (window.location.host == "onboarding.leaseback.de") {
          createURL =
            "https://enquiry.leaseback.de/onboarding/proof/manufacturer";
        }
        let currentObj = this;
        axios
          .post(createURL, {
            manufacturer: currentObj.manufacturer_input_text,
          })
          .then(function(response) {
            if (response.data.isValid == true) {
              currentObj.thirdInputState = false;
            } else {
              currentObj.thirdInputState = true;
            }
          })
          .catch(function(error) {
            currentObj.log("catch Function of AJAX-Called... error()");
            currentObj.log(error);
            currentObj.apiResponse = error;
          });
      }

      if (this.manufacturer_input_text == "") {
        this.thirdInputState = true;
        this.isValid = false;
      } else {
        if (
          this.manufacturer_input_text != "" &&
          this.machinetype_input_text != ""
        ) {
          this.isValid = true;
          this.thirdInputState = false;
        }
      }
    });

    //modell

    EventBus.$on("machinetype_selected", (payload) => {
      this.log("OnboardingStep03 Event received: machinetype_selected");
      this.log("OnboardingStep03 Event received: pre_submit_step_300");
      this.machinetype_input_text = payload.input;
      if (this.machinetype_input_text != "") {
        this.isValid = true;
      } else {
        this.isValid = false;
      }
    });

    EventBus.$on("pre_submit_step_100", () => {
      let currentObj = this;
      EventBus.$emit("submit_step_100", {
        opportunities_area: currentObj.machinecategory_input_text,
        opportunities_producer: currentObj.manufacturer_input_text,
        opportunities_type: this.machinetype_input_text,
      });
    });

    EventBus.$on("evaluateNewMachine", () => {
      this.onboardingMachineCategory= "";
      this.onboardingManufacturer= "";
      this.onboardingMachineType= "";

      this.machinecategory_trigger= false;
      this.machinecategory_trigger_array= [];
      this.machinecategory_input_text= "";

      this.manufacturer_trigger= false;
      this.manufacturer_trigger_array= [];
      this.manufacturer_input_text= "";

      this.machinetype_trigger= false;
      this.machinetype_trigger_array= [];
      this.machinetype_input_text= "";

      this.secondInputState= true;
      this.thirdInputState= true;
      this.isValid=false;
    });
  },
  components: {
    "submit-button": SubmitButton,
    "input-suggestion": InputSuggestion,
    "cta-support-element": CTASupportElement,
  },
  methods: {
    submit: function() {
      this.log(
        "OnboardingStep01.vue: Emitting Event using Submit: " + this.event_name
      );
      EventBus.$emit("" + this.event_name);
    },
    log: function(obj) {
      if (this.debug) {
        this.log(obj);
      }
    },
    changeStep(step) {
      EventBus.$emit("changeStep", {
        step_number: step,
      });
    },
  },
};
</script>

<style scoped>

svg {
  vertical-align: sub;
  margin-right: 10px;
}

.input-icon {
  position: absolute;
  right: 7px;
  top: 14px;
}

.machine-box {
  display: flex;
  margin-bottom: 3rem; 
}

.manufacturer-box {
  width: 50%;
  margin-right: 3rem;
}

.model-box {
  width: 50%;
}


@media (max-width: 1060px) {
  .machine-box {
    flex-direction: column;
  }
  .manufacturer-box {
    width: 100%;
    margin-right: initial;
  }
  .model-box {
    width: 100%;
    margin-right: initial;
  }
}
</style>
